const url = 'https://admin.aristocrat.net';

export default url
